var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBirthdayLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19859",
    "data-name": "Gruppe 19859",
    transform: "translate(-35 -678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19087",
    "data-name": "Gruppe 19087",
    transform: "translate(30 673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_283878",
    "data-name": "Pfad 283878",
    d: "M29.636,21.115a.744.744,0,0,0,.53-.22l6.782-6.782a.75.75,0,0,0-1.06-1.061L29.1,19.834a.75.75,0,0,0,.531,1.281Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_283879",
    "data-name": "Pfad 283879",
    d: "M19.844,17.843a.757.757,0,0,0-.651-.21.747.747,0,0,0-.55.405L6.329,42.665a.75.75,0,0,0,1.006,1.006L31.961,31.358a.75.75,0,0,0,.195-1.2Zm-.325,1.8,4.044,4.045v10.2l-4.657,2.328V21a.791.791,0,0,0-.019-.1ZM17.406,36.958,12.75,39.286V33.177l4.656-9.313Zm-6.156-.781V40c0,.012.006.021.007.033l-2.58,1.29ZM25.063,33.13V25.185l5.3,5.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24312",
    "data-name": "Rechteck 24312",
    width: 2,
    height: 2,
    transform: "translate(29 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24313",
    "data-name": "Rechteck 24313",
    width: 2.113,
    height: 2.052,
    transform: "translate(42 18)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24314",
    "data-name": "Rechteck 24314",
    width: 2.113,
    height: 2.052,
    transform: "translate(40 7.948)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_283880",
    "data-name": "Pfad 283880",
    d: "M25.756,11.45a3.48,3.48,0,0,1,0,4.914L25,17.119a.75.75,0,0,0,1.061,1.061l.754-.755a4.981,4.981,0,0,0,0-7.036L26,9.573a.75.75,0,1,0-1.061,1.061Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_283881",
    "data-name": "Pfad 283881",
    d: "M39.611,23.184a4.983,4.983,0,0,0-7.036,0l-.755.755A.75.75,0,0,0,32.881,25l.755-.755a3.479,3.479,0,0,1,4.915,0l.815.816A.75.75,0,1,0,40.427,24Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19088",
    "data-name": "Gruppe 19088",
    transform: "translate(30 673)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24315",
    "data-name": "Rechteck 24315",
    width: 40,
    height: 40,
    transform: "translate(5 5)",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayLogo);
export default __webpack_public_path__ + "static/media/birthday_logo.e174d0e4bbb602d76f57dad3e0dbbc8f.svg";
export { ForwardRef as ReactComponent };